<div
  class="alert-message"
  [class.error]="type === 'error'"
  [class.warning]="type === 'warning'"
  [class.reminder]="type === 'reminder'"
  [class.confirm-withdraw]="type === 'confirm'"
>
  <img *ngIf="!hiddenIcon && !validateAccount && !loadingIcon" [src]="src" alt="td" />
  <p
    [innerHTML]="message"
    [class.error]="type === 'error'"
    [class.warning]="type === 'warning'"
    [class.reminder]="type === 'reminder'"
    [class.confirm-withdraw]="type === 'confirm'"
  ></p>
  <div *ngIf="loadingIcon" class="loading">
    <div class="circle-loader">
      <div class="checkmark draw"></div>
    </div>
  </div>

  <button *ngIf="validateAccount" class="validate-button" (click)="routeToOnBoarding()">
    Validar cuenta
  </button>
</div>
